import { motion } from "framer-motion";
import { Instagram, GraduationCap, Clock, Building2, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/lib/site";

const AboutCoach = () => (
  <section
    id="about"
    data-testid="about-section"
    className="bg-surface-alt bg-[#F4F1EA] px-6 py-24 md:px-12 md:py-32"
  >
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
      {/* Portrait with clipped frame */}
      <Reveal className="order-1 lg:order-2">
        <div className="relative mx-auto max-w-md">
          <div className="absolute -left-4 -top-4 h-full w-full rounded-t-[200px] border border-secondary" />
          <img
            src={SITE.portrait}
            alt="Dr. Amanjot Kaur, financial coach at IFM FinCoach"
            className="clip-arch relative w-full object-cover object-top"
            style={{ aspectRatio: "4/5" }}
          />
        </div>
      </Reveal>

      <div className="order-2 lg:order-1">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent md:text-sm">
            Hi, I'm {SITE.coach}
          </p>
          <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-primary md:text-6xl">
            Money made simple, practical & judgment-free.
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-8 text-lg font-light leading-relaxed text-foreground/80">
            A Certified Investment Advisor and Soft Skills Trainer with 25 years
            across financial services and banking — from Citibank and HDFC Bank to
            founding Innovative Financial Management (IFM).
          </p>
          <p className="mt-5 text-lg font-light leading-relaxed text-foreground/80">
            My PhD in Management–Finance strengthened my belief that financial
            knowledge should be simple, practical and judgment-free. Today I lead
            financial literacy initiatives that make money make sense for everyone.
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-4">
            <div className="flex items-center gap-3 rounded-full border border-border bg-background px-5 py-3">
              <Clock size={18} className="text-accent" />
              <span className="text-sm font-semibold text-primary">25 Years in Finance</span>
            </div>
            <div className="flex items-center gap-3 rounded-full border border-border bg-background px-5 py-3">
              <GraduationCap size={18} className="text-accent" />
              <span className="text-sm font-semibold text-primary">PhD, Management–Finance</span>
            </div>
            <div className="flex items-center gap-3 rounded-full border border-border bg-background px-5 py-3">
              <BadgeCheck size={18} className="text-accent" />
              <span className="text-sm font-semibold text-primary">Certified Investment Advisor</span>
            </div>
            <div className="flex items-center gap-3 rounded-full border border-border bg-background px-5 py-3">
              <Building2 size={18} className="text-accent" />
              <span className="text-sm font-semibold text-primary">Director, IFM FinCoach</span>
            </div>
          </div>

          <a
            href={SITE.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="about-instagram-btn"
            className="group mt-8 inline-flex items-center gap-3 text-primary"
          >
            <motion.span
              whileHover={{ rotate: 8 }}
              className="flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground"
            >
              <Instagram size={20} />
            </motion.span>
            <span className="border-b border-primary/30 pb-0.5 font-medium transition-colors group-hover:border-accent group-hover:text-accent">
              Follow {SITE.handle}
            </span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default AboutCoach;
